import { formatPrice } from '../../../../../../utils/utils'
import SummaryItem from 'components/SummaryItem/SummaryItem'
import { renderPriceAfterDiscount } from '../../../OrderSummaryUtils'
import * as S from './PriceWithCrossedDiscount.styles'

function PriceWithCrossedDiscount({
  description,
  detailedDescription = {},
  priceBeforeDiscount,
  priceAfterDiscount,
  currency,
  testId = 'price-summary-item',
}) {
  const detailedDescriptions = []
  if (detailedDescription) {
    if (Array.isArray(detailedDescription))
      detailedDescriptions.push(...detailedDescription)
    else {
      detailedDescriptions.push(detailedDescription)
    }
  }

  const text = <span>{description}</span>
  const hightlightedText = detailedDescriptions
    .filter((detailedDescription) => detailedDescription.title)
    .map((detailedDescription) => (
      <span data-testid="promo-code-info">
        <S.HighlightedSubtractIcon />
        {detailedDescription?.subtitle
          ? ` ${detailedDescription?.title}, ${detailedDescription?.subtitle}`
          : ` ${detailedDescription?.title}`}
      </span>
    ))
  const isWithDiscount = priceBeforeDiscount - priceAfterDiscount > 0
  return (
    <SummaryItem testId={testId} text={text} highlightedText={hightlightedText}>
      {isWithDiscount ? (
        renderPriceAfterDiscount(
          currency,
          priceBeforeDiscount,
          priceAfterDiscount
        )
      ) : (
        <span>{formatPrice(priceBeforeDiscount, currency)}</span>
      )}
    </SummaryItem>
  )
}

export default PriceWithCrossedDiscount
